import { calcQuestionChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

// UI chartMode → registry key. Coffee does the mapping in 2 steps (UI → 'columns'/'stacked'/...
// → internal data_lab class name). In React this is 1 step: both the UI mapping and the dl_*
// registry live in a single namespace (chartRegistry).
export const mapToBuilderKey = (chartMode, hasBatches) => {
  if (!hasBatches) {
    // Single-batch: same as regular Column/Bar
    return chartMode // respondents | percents | brespondents | bpercents
  }
  // Multi-batch: Data Lab Columns (corresponds to _chartModeMap in coffee:55-59)
  switch (chartMode) {
    case 'respondents':
      return 'dl_columns'
    case 'percents':
      return 'dl_stacked'
    case 'brespondents':
      return 'dl_bcolumns'
    case 'bpercents':
      return 'dl_bstacked'
    default:
      return 'dl_columns'
  }
}

// The mode asked for (`chartMode`, else the question's declared mode, else the report-wide one),
// then clamped to the modes this chart type can draw.
export const getDefaultChartMode = ({ qType, chartMode, questionChartMode, globalChartMode }) => {
  const mode = calcQuestionChartMode(chartMode, questionChartMode, globalChartMode)

  if (qType === 'bars' && !['respondents', 'brespondents'].includes(mode)) {
    return 'respondents'
  }
  if (qType === 'stacked-bars' && !['percents', 'bpercents'].includes(mode)) {
    return 'percents'
  }
  return mode
}
